/**
 * Waste Element Colors — default color per mappable element type
 *
 * @module core/modules/waste/constants/element-colors
 *
 * @description
 * 10 colores por defecto para los elementos que se representan en el mapa
 * (puntos, líneas o polígonos). Los 3 tipos sin geometría (fleet,
 * organizations, crews, persons) no tienen color de mapa.
 * El usuario puede personalizar cada color desde el panel.
 */

/** The 10 waste element types that have map representation */
export type WasteElementId =
  | 'depots'
  | 'discharge-sites'
  | 'zones'
  | 'service-points'
  | 'secondary-depots'
  | 'transfer-sites'
  | 'supply-points'
  | 'incidents'
  | 'restrictions';

export const WASTE_ELEMENT_COLORS: Record<WasteElementId, string> = {
  'depots':            '#6366f1', // índigo
  'discharge-sites':   '#78716c', // stone
  'zones':             '#06b6d4', // cyan
  'service-points':    '#22c55e', // verde
  'secondary-depots':  '#8b5cf6', // violeta
  'transfer-sites':    '#14b8a6', // teal
  'supply-points':     '#f59e0b', // ámbar
  'incidents':         '#ef4444', // rojo
  'restrictions':      '#ec4899', // rosa
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(WASTE_ELEMENT_COLORS),
);
